/* eslint-disable import/default */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppContainer } from 'react-hot-loader';

import configureStore, { history } from './store/configureStore';
import Root from './components/Root';

const store = configureStore();

const container = document.getElementById('App');
const root = createRoot(container);

root.render(
  <AppContainer>
    <Root store={store} history={history} />
  </AppContainer>
);
